import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { getTimeDetails } from '@app-helpers/functions';
import { ExamService } from '@app-services/test/exam.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-subjectquestionlabel',
  templateUrl: './subjectquestionlabel.component.html',
  styleUrls: ['./subjectquestionlabel.component.css'],
})
export class SubjectquestionlabelComponent implements OnInit {
  @Input('subjects') public subjects:any =[]
  @Input('testReport') public testReport:any =[]
  @Input('viewSolutionAvailableTimebound') public viewSolutionAvailableTimebound:any = false
  @Input('overallpaperResult') public overallpaperResult:any =[]
  @Input('testResultUtility') public testResultUtility :any={}
  public showTooltipindex  = -1;
  public selected_subjectTooltipindex  = -1;
@ViewChild('tooltipBody' , {read: ViewContainerRef}) tooltipBody: ViewContainerRef;
  data: any;
  toolTipStyle = {
    "position": 'absolute',
    "height": "30px",
    "padding": "5px",
    "background": "#E5E9EC",
    "border-radius": "6px",
    "color": '#4E4B66',
    "display": 'flex',
    "border-:radius": '8px',
    "justify-:content": 'center',
    "align-:tems": 'center',
    "top": '20px',
    "left": '20px',
    "z-index":"2",
    "font-size":"14px",
    "font-weight": 500,
    "white-space":"nowrap"
  }
  timeinSec: string;
  

  constructor(private storage: LocalStorageService,public router:Router,private testListService:TestlistService,public examService:ExamService) { }

  ngOnInit(): void {

this.InitializeSubject()
  }
  InitializeSubject(){
    
    if (this.subjects?.length) {
      this.subjects.forEach(v => {
        v.subjectAnalytics = this.testReport?.testSubjects?.find(vin => vin?.subjectName?.toLowerCase() == v?.subjectname?.toLowerCase())||{};
        v?.questions?.forEach((ques:any) => {
          ques.showQuestion = true;
        }) 
          v?.papers?.forEach((pap) => {
            pap.subjectAnalytics = Array.isArray(this.overallpaperResult) ? this.overallpaperResult?.find(vo=>vo?.name =='paper'+pap?.papernum)?.data?.testSubjects?.find(su=>su?.subjectName == pap?.subjectname):{}
            pap?.questions?.forEach((ques:any) => {
              ques.showQuestion = true;
            })           
          })        
        v.selectedSection = ''
      })
    }
  }
  sectionFilter(subject, section, subjindex) {
    this.subjects[subjindex].selectedSection = section
    this.subjects[subjindex].subjectAnalytics.totalCorrectQuestions = 0;
    this.subjects[subjindex].subjectAnalytics.totalInCorrectQuestions = 0;
    this.subjects[subjindex].subjectAnalytics.totalUnAttemptedQuestions = 0;
    this.subjects[subjindex].questions.forEach((question) => {
      question.showQuestion = section ? (question.section == section ? true : false) : true
      if (question.showQuestion && question?.iscorrect == 'Y') {
        this.subjects[subjindex].subjectAnalytics.totalCorrectQuestions = this.subjects[subjindex].subjectAnalytics?.totalCorrectQuestions +1;
      } else if (question.showQuestion && question?.iscorrect == 'N') {
        this.subjects[subjindex].subjectAnalytics.totalInCorrectQuestions = this.subjects[subjindex].subjectAnalytics.totalInCorrectQuestions +   1
      } else if (question.showQuestion && question?.iscorrect == 'NA') {
        this.subjects[subjindex].subjectAnalytics.totalUnAttemptedQuestions = this.subjects[subjindex].subjectAnalytics.totalUnAttemptedQuestions + 1;
      }
    
    })
  }
  moveToViewSolutionPage(subjectindex,queIndex,papernum){
    this.storage.clear('defaulttopicIndex');
    this.storage.clear('questioncounter');
    this.storage.clear('quesresponses');    
    this.storage.store('defaulttopicIndex',subjectindex)
    this.storage.store('questioncounter',queIndex)
    if(this.testResultUtility?.paperSelectedOption && this.testResultUtility?.paperSelectedOption?.indexOf('paper') == -1){
      return false;
    }
    let examinfo = this.storage.retrieve('examinfo')
    if(papernum !=-1){
      const ruleIds = this.testListService.getUSerExamlist?.completedTests?.filter(v => v.subruleid == examinfo?.subruleid)
      examinfo._id = ruleIds[papernum].id
    examinfo.id = ruleIds[papernum].id
      this.storage.store('examinfo',examinfo)
      this.examService.questionsData = null
    } 
    if(this.viewSolutionAvailableTimebound || examinfo?.examtype==  "MOCKTEST" ||  examinfo?.examtype==  'New NEET Mock Test'){
      this.router.navigateByUrl('/dashboard/viewsolutionspage')
    }
  }
  showtoolTip(question,event,index){
 
  const time = getTimeDetails( question?.timeTaken)?.replace(' ',': ')?.replace('m','')
  this.timeinSec = time
    this.showTooltipindex = index;
    this.selected_subjectTooltipindex = event;
  }
  ngOnChanges(){
    this.InitializeSubject()
  }

}
